export default __webpack_public_path__ + "static/media/left-arrow.7d2c99a4.svg";